export function toPercent(value: number, min: number, max: number) {
  const clamped = Math.min(Math.max(value, min), max);
  return ((clamped - min) / (max - min)) * 100;
}
